<template>
  <div class="badges__action">
    <div
      v-if="!liked"
      class="star-btn"
      @click="createLike()"
    >
      <i class="fas fa-star"></i>
    </div>
    <div
      v-else
      class="unstar-btn"
      @click="deleteLike()"
    >
      <i class="fas fa-star"></i>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { csrfToken } from 'rails-ujs'
import * as Sentry from '@sentry/vue'

export default {
  name: 'EventArchiveFavaoriteButtton',
  props: {
    eventArchiveId: {
      type: Number,
      required: true
    },
    like: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      liked: this.like
    }
  },
  created () {
    axios.defaults.headers.common = {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': csrfToken()
    }
  },
  methods: {
    createLike () {
      axios.post('/api/event_archive_likes', { id: this.eventArchiveId }
      ).then(() => (this.liked = true)
      ).catch(error => (Sentry.captureException(error)))
    },
    deleteLike () {
      axios.delete(`/api/event_archive_likes/${this.eventArchiveId}`
      ).then(() => (this.liked = false)
      ).catch(error => (Sentry.captureException(error)))
    }
  }
}
</script>
